// TODO: Centralise
const mobile = matchMedia("(width < 768px)");

class RadialMenuElement extends HTMLElement {
  connectedCallback() {
    window.addEventListener("radial-open", this);
    window.addEventListener("radial-close", this);
    addEventListener("click", this);
  }

  disconnectedCallback() {
    window.removeEventListener("radial-open", this);
    window.removeEventListener("radial-close", this);
    removeEventListener("click", this);
  }

  handleEvent(e) {
    if (e.type === "radial-open") {
      const { bounds } = e.detail;
      this.style.inset = `${bounds.top}px ${bounds.right}px ${bounds.bottom}px ${bounds.left}px`;
      this.toggle(true);
    } else if (e.type === "radial-close") {
      this.toggle(false);
    } else if (e.type === "click") {
      if (this.hasAttribute("open") && e.target.closest("a, button")) {
        const items = [...this.querySelectorAll(".window-container")];
        const item = e.target.closest(".window-container");
        const index = items.indexOf(item);
        this.toggle(false, index);
      }
    }
  }

  toggle(force, index) {
    const fromOpen = this.hasAttribute("open");
    const windows = [...this.querySelectorAll(".window-container")];
    const n = windows.length;
    const toOpen = this.toggleAttribute("open", force);

    if (toOpen === fromOpen) return;

    for (let i = 0; i < n; i++) {
      if (!toOpen && index != null && i === index) {
        windows[i].animate(
          {
            "--window-angle-start": ["var(--window-open-angle-start)", "var(--window-open-angle-start)"],
            "--window-offset": ["var(--window-open-offset)", "var(--window-open-offset)"],
            "--window-scale": ["var(--window-open-scale)", 3],
            "--window-opacity": ["var(--window-open-opacity)", "var(--window-closed-opacity)"],
          },
          {
            duration: 300,
            easing: "ease-in",
          },
        );
      } else {
        windows[i].animate(
          {
            "--window-angle-start": ["var(--window-closed-angle-start)", "var(--window-open-angle-start)"],
            "--window-offset": ["var(--window-closed-offset)", "var(--window-open-offset)"],
            "--window-scale": ["var(--window-closed-scale)", "var(--window-open-scale)"],
            "--window-opacity": ["var(--window-closed-opacity)", "var(--window-open-opacity)"],
          },
          {
            direction: toOpen ? "normal" : "reverse",
            duration: toOpen ? (150 + i * 50) : (100 + (n - i - 1) * 25),
            easing: "ease",
          },
        );
      }
    }
  }
}

customElements.define("radial-menu", RadialMenuElement);

class RadialTriggerElement extends HTMLElement {
  connectedCallback() {
    this.anchor = this.parentElement.querySelector("a");
    this.anchor.addEventListener("mouseenter", this);
  }

  disconnectedCallback() {
    this.anchor.removeEventListener("mouseenter", this);
    removeEventListener("mousemove", this);
  }

  handleEvent(e) {
    if (e.type === "mouseenter") {
      if (mobile.matches) return;
      const icon = this.anchor.querySelector(".icons-icon");
      const bounds = icon.getBoundingClientRect();
      addEventListener("mousemove", this);
      this.dispatchEvent(new CustomEvent("radial-open", { bubbles: true, detail: { bounds } }));
    } else if (e.type === "mousemove") {
      const { clientX, clientY } = e;
      const icon = this.anchor.querySelector(".icons-icon");
      const iconBounds = icon.getBoundingClientRect();
      const iconX = iconBounds.left + 0.5 * iconBounds.width;
      const iconY = iconBounds.top + 0.5 * iconBounds.height;
      const d = Math.sqrt(Math.pow(clientX - iconX, 2) + Math.pow(clientY - iconY, 2));
      if (d > 220) {
        removeEventListener("mousemove", this);
        this.dispatchEvent(new CustomEvent("radial-close", { bubbles: true }));
      }
    }
  }
}

customElements.define("radial-trigger", RadialTriggerElement);
